import React from "react";
import { Button } from "components/shadcn/ui/button";
import { TableSkeleton } from "components/HGTable";
import { XMarkIcon, PlusIcon } from "@heroicons/react/24/outline";
import NewDeviceInputRow from "./NewDeviceInputRow";
import { useFormikContext } from "formik";
import HGStatus from "components/HGStatus";

const EditableTable = ({ openDeleteModal, loading }) => {
    const { values, setFieldValue } = useFormikContext();
    const columns = [
        {
            accessor: "status",
            Header: "Status",
        },
        {
            accessor: "serialNumber",
            Header: "Serial Number",
        },
        {
            accessor: "deviceType",
            Header: "Device Type",
        },
    ];

    return (
        <div>
            {loading ? (
                <TableSkeleton columns={columns} />
            ) : (
                <table className="HGTable bg-card text-card-foreground rounded-[10px] p-0">
                    <thead>
                        <tr>
                            {columns.map((column) => (
                                <th key={column.Header}>{column.Header}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {values?.existingDevices?.length === 0 &&
                        values.newDevices.length === 0 ? (
                            <tr style={{ borderTop: "1px solid #f0f0f0" }}>
                                <td colSpan={columns.length + 1}>
                                    <p className="text-base opacity-20 text-center capitalize w-full">
                                        no device available
                                    </p>
                                </td>
                            </tr>
                        ) : (
                            <>
                                {values.existingDevices?.map((item, idx) => (
                                    <tr key={idx}>
                                        {columns.map((column) => {
                                            let value = item[column.accessor];
                                            if (column.accessor === "status") {
                                                value = (
                                                    <HGStatus status="online" />
                                                );
                                            }
                                            if (
                                                column.accessor ===
                                                    "deviceType" &&
                                                !item[column.accessor]
                                            ) {
                                                value = "Microinverter";
                                            }
                                            return (
                                                <td key={column.Header}>
                                                    {value}
                                                </td>
                                            );
                                        })}
                                        <td>
                                            <div className="flex justify-end">
                                                <Button
                                                    variant="outline"
                                                    size="sm"
                                                    className="min-w-[35px] p-0"
                                                    onClick={() => {
                                                        openDeleteModal(item);
                                                        console.log(
                                                            `delete ${item.name}: ${item.serialNumber} `
                                                        );
                                                    }}
                                                >
                                                    <XMarkIcon className="w-4 h-4" />
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </>
                        )}
                        <NewDeviceInputRow />
                        <tr>
                            <td colSpan={columns.length + 1}>
                                <div>
                                    <Button
                                        variant="secondary"
                                        className="w-full"
                                        onClick={() =>
                                            setFieldValue("newDevices", [
                                                ...values.newDevices,
                                                { serialNumber: "" },
                                            ])
                                        }
                                    >
                                        <PlusIcon className="w-4 h-4" />
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default EditableTable;
